export default {
  styleOverrides: {
    root: {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  },
};
